export class PostLead {
	private loan_purpose:              string;
	private credit_rating:             string;
	private desired_rate_type:         string;
	private property_use:              string;
	private estimated_down_payment:    string;
	private found_home:                string;
	private signed_purchase_agreement: string;
	private buying_process:            string;
	private property_type:             string;
	private veteran_military:          string;
	private new_home_value:            string;
	private first_name:                string;
	private last_name:                 string;
	private property_city:             string;
	private property_state:            string;
	private current_fha:               string;
	private current_va:                string;
	private zipcode:                   string;
	private campaign:                  string;
	private page_type:                 string;
	private street_address:            string;
	private phone:                     string;
	private phone_2:                   string;
	private days_from_buying:          string;
	private lead_referrer:             string;
    private lead_referrer_string:      string;
	private first_time_buyer:          string;
	private self_employed:             string;
	private cash_out:                  number;
	private cash_out_reason:           string;
	private cash_out_reason_detail:    string;
	private property_value:            number;
	private first_mortgage_balance:    number;
	private second_mortgage_balance:   number;
	private flow_type:                 string = 'conventional';
	private form_version:              string = 'email-verification';
	private has_existing_mortgage:	   string;


	public email:                 string;
	public trusted_form_cert_url: string;
	public universal_leadid:      string;
	public medium:                string;
	public adnetwork:             string = 'consumer_campaign';
	public client_id:             string;
  public position:              string;
  public fru_source:            string;
	public form_type:             string;
	public experiment:            string;
	public experiment_variation:  string;
	public network:				  string;
	public gclid:				  string;
  public clickid:				  string;
	public time_frame:			  string;
	public housing_situation:	  string;
	public bankruptcy_recency:	  number;
	public foreclosure_recency:	  number;
	public experiment_data:       string;
	public abandonment:			  boolean = false;
  public lenders_count: string;
  public consent_source: string;
  public submission_id: string;
  public email_typed: number;

	constructor(lead: any) {
		this.loan_purpose = lead.type; // This first

		for (let p in lead) {
			this[p] = lead[p];
		}
	}

	set type(p: string) {
		switch (p) {
			case 'purchase':
				this.loan_purpose = 'purchase';
				break;

			case 'refinance':
			case 'heloc':
			case 'cashout':
			case 'homeimprovement':
			default:
				this.loan_purpose = 'refinance';
				break;
		}
	}

	set phoneNumber(p: string) {
		this.phone = p.replace(/[^\d]/g, '').slice(0, 10);
	}

	set phone_number(p: string) {
		this.phone_2 = p.replace(/[^\d]/g, '').slice(0, 10);
	}

	set streetAddress(p: string) {
		this.street_address = p;
	}

	set formVersion(p: string) {
		this.form_version = p;
	}

	set flowType(p: string) {
		this.flow_type = p;
	}

	set creditRating(p: string) {
		this.credit_rating = p;
	}

	set rateType(p: string) {
		if (!p) {
			return;
		}
		this.desired_rate_type = p;
	}

	set propertyUse(p: string) {
		this.property_use = p;
	}

	set downPayment(p: string) {
		this.estimated_down_payment = p;
	}

	set foundHome(p: string) {
		this.found_home = p;
	}

	set signedAgreement(p: string) {
		this.signed_purchase_agreement = p;
	}

	set buyingProcess(p: string) {
		this.buying_process = p;
	}

	set propertyType(p: string) {
		this.property_type = p;
	}

	set veteranMilitary(p: string) {
		this.veteran_military = p;
	}

	set purchasePrice(p: string) {
		this.new_home_value = p;
	}

	set firstName(p: string) {
		this.first_name = p.trim();
	}

	set lastName(p: string) {
		this.last_name = p.trim();
	}

	set propertyCity(p: string) {
		this.property_city = p;
	}

	set propertyState(p: string) {
		this.property_state = p;
	}

	set zipCode(p: string) {
		this.zipcode = p;
	}

	set cashOut(p: number) {
		this.cash_out = p;
	}

	set cashOutReason(p: string) {
		this.cash_out_reason = p;
	}

	set cashOutReasonDetail(p: string) {
		this.cash_out_reason_detail = p;
	}

	set propertyValue(p: number) {
		this.property_value = p;
	}

	set firstMortgageBalance(p: number) {
		this.first_mortgage_balance = p;
	}

	set hasExistingMortgage(p: string) {
		this.has_existing_mortgage = p;
	}

	set currentFHA(p: string) {
		this.current_fha = p;
	}

	set pageType(p: string) {
		this.page_type = p;
	}

	set trustedFormUrl(p: string) {
		this.trusted_form_cert_url = p;
	}

	set experimentVariation(p: string) {
		this.experiment_variation = p;
	}

	set jornayaLeadId(p: string) {
    this.universal_leadid = p;
  }

  set newHomeValue(p: string) {
		this.new_home_value = p;
	}

	set daysFromBuying(p: string) {
		this.days_from_buying = p;
	}

	set estimatedDownPayment(p: string) {
		this.estimated_down_payment = p;
	}

	set leadReferrer(p: string) {
		this.lead_referrer = JSON.stringify(p);
	}

	set leadReferrerString(p: string) {
    this.lead_referrer_string = JSON.stringify(p);
  }

  set firstTimeBuyer(p: string) {
		this.first_time_buyer = p;
	}

	set selfEmployed(p: string) {
		this.self_employed = p;
	}

	set clientId(p: string) {
		this.client_id = p;
	}

	set clientPosition(p: string) {
    this.position = p;
  }

  set fruSource(p: string) {
    this.fru_source = p;
  }

  set formType(p: string) {
		this.form_type = p;
	}

	set netWork(p: string) {
		this.network = p;
	}

	set gclId(p: string) {
		this.gclid = p;
	}

  set clickId(p: string) {
		this.clickid = p;
	}

	set timeFrame(p: string) {
		this.time_frame = p;
	}

	set housingSituation(p: string) {
		this.housing_situation = p;
	}

	set experimentData(p: string) {
		this.experiment_data = JSON.stringify(p);
	}

	set bankruptcyRecency(p: number) {
		this.bankruptcy_recency = p;
	}

	set foreclosureRecency(p: number) {
		this.foreclosure_recency = p;
	}

  set lendersCount(p: string) {
    this.lenders_count = p;
  }

  set submissionId(p: string) {
    this.submission_id = p;
  }

  set emailTyped(p: number) {
    this.email_typed = p;
  }
}
